import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FallOffIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 0.25C5.521 0.25 0.25 5.521 0.25 12C0.25 18.479 5.521 23.75 12 23.75C18.479 23.75 23.75 18.4785 23.75 12C23.75 5.5215 18.4785 0.25 12 0.25ZM12 22.25C6.3481 22.25 1.75 17.6523 1.75 12C1.75 6.3477 6.3481 1.75 12 1.75C17.6519 1.75 22.25 6.3481 22.25 12C22.25 17.6519 17.6523 22.25 12 22.25Z"
        fill={color}
      />
      <path
        d="M12 4C7.5889 4 4 7.5889 4 12C4 16.4111 7.5889 20 12 20C16.4111 20 20 16.4111 20 12C20 7.5889 16.4111 4 12 4ZM12 18C8.6914 18 6 15.3086 6 12C6 8.6914 8.6914 6 12 6C15.3086 6 18 8.6914 18 12C18 15.3086 15.3086 18 12 18Z"
        fill={color}
      />
      <path
        d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FallOffIcon.displayName = 'FallOffIcon';
